export class CustomerTypeData {
  private customerTypeList: string[] = ["Individual".toUpperCase(), "Joint".toUpperCase()];
    public getCustomerTypeList(): Array<string> {
        return this.customerTypeList;
    }
}
